import _ from 'lodash';

type TEnvMode = 'development' | 'production';

type TPartialWindowConfig = Partial<Window['CONFIG']>;

type TConfig = Record<TEnvMode, TPartialWindowConfig>;

const envMode = import.meta.env.MODE as TEnvMode;

// By default it will use variables defined in a .env file for local testing purposes
const envVariables = {
  apiKey: import.meta.env.VITE_API_KEY,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  marekImagesBucketDomain: import.meta.env.VITE_MAREK_IMAGES_BUCKET_DOMAIN,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
} satisfies TPartialWindowConfig;

const config = {
  development: envVariables,
  production: envVariables,
} satisfies TConfig;

export default _.merge(window.CONFIG, config[envMode]) as TPartialWindowConfig;
